import { render, staticRenderFns } from "./Underline.vue?vue&type=template&id=67317cbc&scoped=true&"
import script from "./Underline.vue?vue&type=script&lang=js&"
export * from "./Underline.vue?vue&type=script&lang=js&"
import style0 from "./Underline.vue?vue&type=style&index=0&id=67317cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67317cbc",
  null
  
)

export default component.exports